import { toRem } from '@subaio/components'
import { themeHelpers } from '@subaio/utils'

const colorsLight = {
	primary: '#00716b',
	primaryActive: '#005c54',
	primaryOpaque: '#EDF7F7',

	pageBackground: '#f3f3f3',
	background: '#FFFFFF',
	text: '#222222',
	textHeader: '#222222',
	textButton: '#FFFFFF',
	textButtonOpaque: '#004C4C',
	textMuted: '#666666',
	textLight: '#4D4D4D',
	textInverted: '#f3f3f3',
	textSubtitle: '#666666',
	link: '#00716b',
	linkHighlight: '#00857a',
	linkDisabled: '#666666',
	linkDisabledSubtitle: '#222222',
	border: '#CCCCCC',
	borderMuted: '#DEDEDE',
	chevron: '#B3B3B3',
	separator: '#e9e9e9',
	divider: '#f0f0f0',
	listHeader: '#666666',
	listActive: '#EDF7F7',
	subtitleBackground: '#f3f3f3',
	danger: '#C21700',
	inputBorder: '#666666',
	inputBorderHighlight: '#00857a',
	inputBorderDisabled: '#808080',
	inputFocus: '#004C4C',
	inputClear: '#808080',
	inputCheckMark: '#FFFFFF',
	inputCheckBorder: '#004C4C',
	inputDisabled: '#f3f3f3',
	inputTextDisabled: '#808080',
	disabled: '#808080',
	disabledContrast: '#CCCCCC',
	icon: '#004C4C',
	iconContent: '#004C4C',
	iconBackground: '#D8F0EF',
	itemTitle: '#004C4C',
	itemSubtitle: '#4F706F',
	spinnerBackground: '#37ABA1',
	spinnerPrimary: '#FFD200',
	spinnerSecondary: '#86D1CD',
	buttonFocus: '#005FCC',
	chevronClose: '#959595',
	bannerAccent: '#005CDE',
	bannerBorder: '#E9E9E9',

	badgeBackground: '#EDFAFF',
	badgeText: '#0070E9',

	elevatedShadowTop: 'rgba(34, 34, 34, 0.02)',
	elevatedShadowBottom: 'rgba(34, 34, 34, 0.15)',
	transactionLogoBackground: '#37ABA1',
}

export const fontSizes = {
	header: toRem(28),
	subheader: toRem(24),
	// Icon size should only partially scale with global font size
	icon: `calc(12px + ${toRem(12)})`,
	base: toRem(16),
	baseSmall: toRem(14),
	caption: toRem(12),

	inputLabel: toRem(12),
}

export const fontFamilies = {
	header: `'ABN AMRO Sans', sans-serif`,
	base: `'ABN AMRO Sans', sans-serif`,
	input: `Roboto, 'Helvetica Neue', Arial, sans-serif`,
}

export const getTheme = () => ({
	color: colorsLight,
	colorScheme: 'light',
	font: {
		family: fontFamilies,
		size: fontSizes,
	},
})

export const helpers = themeHelpers(getTheme())

export type Theme = ReturnType<typeof getTheme>
